<template>
  <li
    :class="[
      ns.e('item'),
      ns.is(selected ? 'selected' : ''),
      ns.is(disabled ? 'disabled' : ''),
      ns.is(divided ? 'divided' : '')
    ]"
    @click="onClick"
  >
    <slot></slot>
  </li>
</template>

<script lang="ts">
import { defineComponent, inject } from 'vue'
import {
  dropdownItemProps,
  DropdownContextKey
} from './dropdown'
import { useNamespace } from '@sgui-plus/hooks'

export default defineComponent({
  name: 'SgDropdownItem',
  props: dropdownItemProps,
  setup (props) {
    const ns = useNamespace('dropdown')

    const { onClickItem } = inject(DropdownContextKey, { onClickItem: (name) => name })!

    function onClick(event) {
      event?.stopPropagation()
      event?.preventDefault()
      if (props.disabled) return
      onClickItem(props.name)
    }

    return {
      ns,
      onClick
    }
  }
})
</script>
